<template>
  <v-sheet>
    <div class="d-flex justify-end">
      <v-btn
        id="js-list-add-button"
        class="default-action-btn"
        @click="fireEvent('list:addItem')"
        v-if="showAdd"
        small
      >
        Add
      </v-btn>
    </div>
    <v-list :id="listId">
      <div v-for="listItem in listItems" v-bind:key="listItem.id">
        <v-list-item
          :style="`background-color:${background}`"
          class="js-list-item"
        >
          <v-list-item-content>
            <a
              v-if="linksAsDownloads"
              :href="link(listItem)"
              target="_blank"
              download=""
              >{{ listItem.name }}</a
            >
            <router-link v-else-if="link" :to="link(listItem)">
              <v-avatar v-if="listItem.avatar" size="40px">
                <img :src="listItem.avatar" alt="personal avatar missing?" />
              </v-avatar>
              {{ listItem.name }}
            </router-link>
            <div v-else>
              <v-avatar v-if="listItem.avatar" size="40px">
                <img :src="listItem.avatar" alt="personal avatar missing?" />
              </v-avatar>
              <v-img
                v-if="listItem.url"
                :src="listItem.url"
                width="75px"
              ></v-img>
              {{ listItem.name }}
            </div>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              class="default-action-btn"
              @click="deleteItem(listItem.id)"
              v-model="listItem.id"
              v-if="showDelete"
              small
            >
              Delete
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>
    </v-list>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: {
    showAdd: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
    listItems: { type: Array, default: () => [] },
    link: { type: Function, default: undefined },
    linksAsDownloads: { type: Boolean, default: false },
    listId: { type: String, default: "" },
    backgroundColor: { type: String, default: "" }
  },
  methods: {
    deleteItem(listItemId) {
      if (confirm("Are you sure you want to delete this? OK to delete.")) {
        this.fireEvent("list:removeItem", listItemId)
      }
    }
  },
  computed: {
    background() {
      return this.backgroundColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

a:link {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
